// src/backendServices/broadcastingManagment/api_broadcastingChannel.ts


import   axios                                           from 'axios';
import { BackendResponse                              ,
         handleError                                  }  from '../../dataTypes/backendServicesManagment/types';
import { BroadcastedMedia                             ,
         BroadcastingChannel                          ,
         initializedBroadcastingChannel               ,
         EnrichedBroadcastingChannel                  ,
         initializedEnrichedBroadcastingChannel       ,
         EnrichedBroadcastedMedia                     ,
         initializedEnrichedBroadcastedMedia          ,
		 CurrentStreamMetadata,
         ProgramMetadata,
         XtreamConnectionCount,
         initializedXtreamConnectionCount,
         XtreamConnectionLocations,
         initializedXtreamConnectionLocations}  from '../../dataTypes/broadcastingManagment/types';
		 
		 
import { ThirdPartyStreamingChannel                   ,
         initializedThirdPartyStreamingChannel        }  from '../../dataTypes/broadcastingManagment/types_thirdPartyStreamingSystem';
import { retrieveMediaList                            }  from '../../store/mediaManagment/actions';
import { initializedMedia                             }  from '../../dataTypes/mediaManagment/types';
import { Video                             }  from '../../dataTypes/mediaManagment/video_types';
import { AudioSlideshow                    }  from '../../dataTypes/mediaManagment/audioSlideshow_types';
import { API_URLS                                     ,
         WWW_URLS                                     ,
         WWW_DOMAIN                                   }  from '../urls';
import { createUpload                                 }  from '../fileManagment/uploadWithStore';
import { convertTimeToSeconds                         }  from '../../dataTypes/timeManagment/utils';

import { generateSlug                                 }  from '../../utils/utils_string';

import { getBroadcastedMediaList                      }  from './api_broadcastedMedia';
import { keepPriorityArchives                         }  from '../../dataTypes/broadcastingManagment/scheduleOperations';

/**
 * Lance l'upload du son d'attente en arrière-plan, par morceaux.
 *
 * Ce fichier voyageait auparavant dans le FormData de la fiche : l'enregistrement d'une
 * chaîne restait bloqué le temps du transfert ET du traitement serveur, ce qui devient
 * intenable dès que le son pèse quelques dizaines de mégaoctets. Le finalize côté API se
 * charge de recharger la mire une fois le fichier en place.
 */
const uploadPendingSoundInBackground = ( broadcastingChannelId: number , pendingSoundFileToUpload: File ): void => {
  const uploadConfig = {
    uploadChunkUrl    : API_URLS.uploadPendingSoundChunk,
    finalizeUploadUrl : API_URLS.finalizePendingSoundUpload,
    chunkSize         : 5 * 1024 * 1024, // 5MB, comme les sons de la bibliothèque
    maxRetries        : 3,
    enableResume      : true,
    entityId          : broadcastingChannelId,
    entityType        : 'broadcastingChannel',
    autoStart         : true,
    metadata          : {
      broadcastingChannelId : broadcastingChannelId,
      mediaType             : 'pendingSound'
    }
  };

  const uploader = createUpload(pendingSoundFileToUpload, uploadConfig);
  console.log(`Upload du son d'attente démarré en arrière-plan pour la chaîne ID: ${broadcastingChannelId}, Upload ID: ${uploader.id}`);
};


export const parseBroadcastedMedias = (medias: any[]): BroadcastedMedia[] => {
  return medias.map((media) => ({
    id              : media.id        ?? 0  ,
    mediaId         : media.mediaId   ?? 0  ,
    broadcastDate   : media.broadcastDate ? new Date(media.broadcastDate) : null,
    status          : media.status    ?? '' ,
    actualStartTime : media.actualStartTime && media.actualStartTime !== '' ? new Date(media.actualStartTime) : null,
    audioTrackIndex : media.audioTrackIndex ?? null,
    loop            : media.loop === true,
    priority        : media.priority === true,
  }));
};

const mapThirdPartyStreamingChannels = (thirdPartyStreamingChannels: any[]): ThirdPartyStreamingChannel[] =>
  thirdPartyStreamingChannels.map((thirdPartyStreamingChannel) => ({
    ...initializedThirdPartyStreamingChannel(),
    id                           : thirdPartyStreamingChannel.id                           ?? 0,
    active                       : thirdPartyStreamingChannel.active                       ?? false,
    name                         : thirdPartyStreamingChannel.name                         ?? null,
    description                  : thirdPartyStreamingChannel.description                  ?? null,
    ingestionKey                 : thirdPartyStreamingChannel.ingestionKey                 ?? null,
    streamUrl                    : thirdPartyStreamingChannel.streamUrl                    ?? null,
    watchUrl                     : thirdPartyStreamingChannel.watchUrl                     ?? null,
    broadcastingChannelId        : thirdPartyStreamingChannel.broadcastingChannelId        ?? null,
    thirdPartyStreamingServiceId : thirdPartyStreamingChannel.thirdPartyStreamingServiceId ?? null,
  }));

export interface BackendResponse_BroadcastingChannelList extends BackendResponse<BroadcastingChannel[]> {}

export const getBroadcastingChannelList = async (detailled: boolean = true, adminId?: number): Promise<BackendResponse_BroadcastingChannelList> => {

  const url = detailled ? API_URLS.getDetailledBroadcastingChannelList : API_URLS.getBroadcastingChannelList;

  const headers = {
    // 'User-Agent-Informations': `${userAgentInformations}`,
    // 'App-Informations': `${appInformations}`,
  };

  let result: BackendResponse_BroadcastingChannelList = {
    code: 0,
    comment: '',
    payload: [],
  };

  try 
   {
    const response = await axios.get(url, { headers: headers, params: adminId ? { adminId } : {} });

    console.log ('getBroadcastingChannelList', url, response)

    if (response.status === 200) 
	      {
           const broadcastingChannels: BroadcastingChannel[] = response.data.map((channel: any) => {
        
		     return {   
                      id                          : channel.id                   ?? 0     ,    
		              uuid                        : channel.uuid                 ?? ''    ,
		              publicRef                   : channel.publicRef                 ?? ''    ,
		              creationDate                : channel.creationDate         ?? null    ,
		              name                        : channel.name                 ?? ''    ,
		              slug                        : channel.slug                 ?? ''    ,
                      description                 : channel.description          ?? ''    ,
		              active                      : channel.active               ?? false ,
                      channelStatus               : channel.channelStatus         ?? (channel.active ? 'active' : 'inactive') ,
                      activeScheduled             : channel.activeScheduled      ?? false     ,     
                      activeStartDate             : channel.activeStartDate      ?? null ,     // Si non nul alors actif après cette date, sinon actif/inactif immédiatement
                      activeEndDate               : channel.activeEndDate        ?? null ,     // Si non nul alors actif après cette date, sinon actif/inactif immédiatement
                      publicPortal                : channel.publicPortal         ?? false,
                      ephemeral                   : channel.ephemeral            ?? false,
                      orientation              : channel.orientation === 'portrait' ? 'portrait' : 'landscape',
                      chatModeration              : channel.chatModeration       ?? 0     ,
                      createdFromRegie            : channel.createdFromRegie     ?? false ,
                      stageOpen                   : channel.stageOpen            ?? false ,
                      mode                        : channel.mode                 ?? ''    ,
                      streamSource                : channel.streamSource         ?? ''    ,
                      defaultStreamSource         : channel.defaultStreamSource  ?? ''    ,
          
                      logoImageFile               : channel.logoImageFile        ?? ''    ,
                      pendingImageFile            : channel.pendingImageFile     ?? ''    ,
                      pendingSoundFile            : channel.pendingSoundFile     ?? ''    ,
                      originalLogoImageFile       : channel.originalLogoImageFile    ?? ''    ,
                      originalPendingImageFile    : channel.originalPendingImageFile ?? ''    ,
                      originalPendingSoundFile    : channel.originalPendingSoundFile ?? ''    ,
		              showTitle                   : channel.showTitle            ?? false,
		              showDate                    : channel.showDate             ?? false,
		              titleFont                   : channel.titleFont            ?? 'Arial'  ,
		              titleColor                  : channel.titleColor           ?? '#FFFFFF',
		              titleX                      : channel.titleX               ?? 0        ,
		              titleY                      : channel.titleY               ?? 0        ,
		              titleSize                   : channel.titleSize            ?? 64       ,
		              titleBoxOpacity             : channel.titleBoxOpacity      ?? 60       ,
		              dateBoxOpacity              : channel.dateBoxOpacity       ?? 60       ,
		              titleBold                   : channel.titleBold            ?? false    ,
		              titleUnderline              : channel.titleUnderline       ?? false    ,
		              titleItalic                 : channel.titleItalic          ?? false    ,
		              dateFont                    : channel.dateFont             ?? 'Arial'  ,
		              dateColor                   : channel.dateColor            ?? '#FFFFFF',
		              dateX                       : channel.dateX                ?? 0        ,
		              dateY                       : channel.dateY                ?? 0        ,
		              dateSize                    : channel.dateSize             ?? 64       ,
		              dateBold                    : channel.dateBold             ?? false    ,
		              dateUnderline               : channel.dateUnderline       ?? false    ,
		              dateItalic                  : channel.dateItalic          ?? false    ,
		              timezone                    : channel.timezone             ?? 'Europe/Paris',

                      requiredUserStatusId        : channel.requiredUserStatusId ?? -1    ,
		  
                      keywordsIds                 : detailled ? (channel.keywordsIds?.map((keyword: any) => keyword.id) || [])  : [],
                      categoriesIds               : detailled ? (channel.broadcastingChannelCategories?.map((category: any) => category.id) || [])  : [],
                      associatedProductIds        : detailled ? (channel.associatedProductIds?.map((product: any) => product.id) || []) : [],
   
                      thirdPartyStreamingChannels : detailled ? ( mapThirdPartyStreamingChannels(channel.thirdPartyStreamingChannels ?? [])) : [],

                      ingestionUrl                : '',
                      watchingUrl                 : channel.watchingUrl ? channel.watchingUrl : ( channel.name ? `https://${WWW_DOMAIN}/${generateSlug(channel.name)}/stream.m3u8` : '' ) ,

                      // `rtsp://${WWW_DOMAIN}/${generateSlug(initialBroadcastingChannel.name)}`
                      // `https://${WWW_DOMAIN}/${generateSlug(initialBroadcastingChannel.name)}/stream.m3u8`

                      ipTvGenericalUser              : channel.ipTvGenericalUser ?? '',
                      ipTvGenericalPwd               : channel.ipTvGenericalPwd ?? '',  
  
                      currentBroadcastedMediaId   : channel.currentBroadcastedMediaId   ?? 0  ,
                      currentBroadcastedMediaName : channel.currentBroadcastedMediaName ?? '' ,
                      currentNumberOfConnections  : channel.currentNumberOfConnections  ?? 0  ,
                      broadcastedMedias           : detailled ? (channel.broadcastedMedias ? parseBroadcastedMedias(channel.broadcastedMedias) : []) : [],
                    };
           });

           result = {
                      code: 1,
                      comment: 'Récupération des canaux de diffusion réussie.',
                      payload: broadcastingChannels,
                    };
          } 
	 else {
           result = handleError<BroadcastingChannel[]>(-101, `Erreur lors de la récupération des canaux de diffusion : ${response.status}`);
          }
   } 
  catch (error) 
   {
    console.log(error);
    result = handleError<BroadcastingChannel[]>(-102, 'Network error');
   }

  return result;
};

export interface BackendResponse_BroadcastingChannel extends BackendResponse<BroadcastingChannel> {}

export const getBroadcastingChannel = async (channelId: number): Promise<BackendResponse_BroadcastingChannel> => {


  const baseUrl = `${API_URLS.getBroadcastingChannel}`;
  const url     = baseUrl.replace('{id}', `${channelId}`);

  const headers = {
    // 'User-Agent-Informations': `${userAgentInformations}`,
    // 'App-Informations': `${appInformations}`,
  };

  let result: BackendResponse_BroadcastingChannel = {
    code: 0,
    comment: '',
    payload: initializedBroadcastingChannel(),
  };

  try 
   {
    const response = await axios.get(url, { headers: headers });

    console.log ('>>>>>>>>>>>>>>>>> getBroadcastingChannel', response)

    if (response.status === 200) 
	      {
           const broadcastingChannel : BroadcastingChannel = {

              id                          : response.data.id                   ?? 0     ,    
		      uuid                        : response.data.uuid                 ?? ''    ,
		      publicRef                   : response.data.publicRef                 ?? ''    ,
		      rtmpLogin                   : response.data.rtmpLogin            ?? undefined ,
		      rtmpPassword                : response.data.rtmpPassword         ?? undefined ,
		      creationDate                : response.data.creationDate         ?? null    ,
		      name                        : response.data.name                 ?? ''    ,
		      slug                        : response.data.slug                 ?? ''    ,
	          description                 : response.data.description          ?? ''    ,
              active                      : response.data.active               ?? false ,
              channelStatus               : response.data.channelStatus        ?? (response.data.active ? 'active' : 'inactive') ,
              activeScheduled             : response.data.activeScheduled      ?? false     ,     
              activeStartDate             : response.data.activeStartDate      ?? null ,     // Si non nul alors actif après cette date, sinon actif/inactif immédiatement
              activeEndDate               : response.data.activeEndDate        ?? null ,     // Si non nul alors actif après cette date, sinon actif/inactif immédiatement
              publicPortal                : response.data.publicPortal         ?? false,
              ephemeral                   : response.data.ephemeral            ?? false,
              orientation                : response.data.orientation === 'portrait' ? 'portrait' : 'landscape',
              videoProfile               : response.data.videoProfile ?? undefined,
              multiview                   : response.data.multiview            ?? false,
              ownerId                     : response.data.ownerId              ?? null,
              ownerUseFiligrane           : response.data.ownerUseFiligrane    ?? false,
              chatModeration              : response.data.chatModeration       ?? 0     ,
              createdFromRegie            : response.data.createdFromRegie     ?? false ,
              stageOpen                   : response.data.stageOpen            ?? false ,
              mode                        : response.data.mode                 ?? ''    ,
              streamSource                : response.data.streamSource         ?? ''    ,
              defaultStreamSource         : response.data.defaultStreamSource  ?? ''    ,
              logoImageFile               : response.data.logoImageFile        ?? ''    ,
              pendingImageFile            : response.data.pendingImageFile     ?? ''    ,
              pendingSoundFile            : response.data.pendingSoundFile     ?? ''    ,
              originalLogoImageFile       : response.data.originalLogoImageFile    ?? ''    ,
              originalPendingImageFile    : response.data.originalPendingImageFile ?? ''    ,
              originalPendingSoundFile    : response.data.originalPendingSoundFile ?? ''    ,
	          showTitle                   : response.data.showTitle            ?? false ,
	          showDate                    : response.data.showDate             ?? false ,
	          titleFont                   : response.data.titleFont            ?? 'Arial'   ,
	          titleColor                  : response.data.titleColor           ?? '#FFFFFF' ,
	          titleX                      : response.data.titleX               ?? 0         ,
	          titleY                      : response.data.titleY               ?? 0         ,
	          titleSize                   : response.data.titleSize            ?? 64        ,
	          titleBoxOpacity             : response.data.titleBoxOpacity      ?? 60        ,
	          dateBoxOpacity              : response.data.dateBoxOpacity       ?? 60        ,
	          titleBold                   : response.data.titleBold            ?? false     ,
	          titleUnderline              : response.data.titleUnderline       ?? false     ,
	          titleItalic                 : response.data.titleItalic          ?? false     ,
	          dateFont                    : response.data.dateFont             ?? 'Arial'   ,
	          dateColor                   : response.data.dateColor            ?? '#FFFFFF' ,
	          dateX                       : response.data.dateX                ?? 0         ,
	          dateY                       : response.data.dateY                ?? 0         ,
	          dateSize                    : response.data.dateSize             ?? 64        ,
	          dateBold                    : response.data.dateBold             ?? false     ,
	          dateUnderline               : response.data.dateUnderline       ?? false     ,
	          dateItalic                  : response.data.dateItalic          ?? false     ,
	          timezone                    : response.data.timezone             ?? 'Europe/Paris',
			  requiredUserStatusId        : response.data.requiredUserStatusId ?? -1    ,
	          keywordsIds                 : response.data.keywords?.map((keyword: any) => keyword.id) || [],
              categoriesIds               : response.data.broadcastingChannelCategories?.map((category: any) => category.id) || [],
              associatedProductIds        : response.data.associatedProductIds?.map((product: any) => product.id) || [],
              thirdPartyStreamingChannels : mapThirdPartyStreamingChannels(response.data.thirdPartyStreamingChannels ?? []),
 
              ingestionUrl                : '',
              watchingUrl                 : response.data.watchingUrl ? response.data.watchingUrl : ( response.data.name ? `https://${WWW_DOMAIN}/${generateSlug(response.data.name)}/stream.m3u8` : '' ) ,

              // `rtsp://${WWW_DOMAIN}/${generateSlug(initialBroadcastingChannel.name)}`
              // `https://${WWW_DOMAIN}/${generateSlug(initialBroadcastingChannel.name)}/stream.m3u8`

              ipTvGenericalUser              : response.data.ipTvGenericalUser ?? '',
              ipTvGenericalPwd               : response.data.ipTvGenericalPwd ?? '',  

              currentBroadcastedMediaId   : response.data.currentBroadcastedMediaId   ?? 0  ,
              currentBroadcastedMediaName : response.data.currentBroadcastedMediaName ?? '' ,
              currentNumberOfConnections  : response.data.currentNumberOfConnections  ?? 0  ,
              broadcastedMedias           : response.data.broadcastedMedias ? parseBroadcastedMedias(response.data.broadcastedMedias) : [],
            };


     console.log ('>>>>>>>>>>>>>>>>> getBroadcastingChannel', broadcastingChannel)



           result = {
                      code: 1,
                      comment: 'Récupération des canaux de diffusion réussie.',
                      payload: broadcastingChannel,
                    };
          } 
	 else {
           result = handleError<BroadcastingChannel>(-101, `Erreur lors de la récupération des canaux de diffusion : ${response.status}`);
          }
   }
  catch (error) 
   {
    result = handleError<BroadcastingChannel>(-102, 'Network error');
   }


  return result;
};

export interface BackendResponse_MireFonts extends BackendResponse<string[]> {}

// Polices réellement installées sur le microservice (fontconfig) — à utiliser dans les menus
// déroulants de police de la mire d'attente, à la place des polices du navigateur de l'admin.
// Ne dépend pas d'un canal précis : tous les microservices partagent la même image Docker.
export const getBroadcastingChannelMireFonts = async (): Promise<BackendResponse_MireFonts> => {

  const url = `${API_URLS.getBroadcastingChannelMireFonts}`;

  console.log('[getBroadcastingChannelMireFonts] GET', url);

  try
   {
    const response = await axios.get(url);

    console.log('[getBroadcastingChannelMireFonts] réponse', response.status, response.data);

    if (response.status === 200 && Array.isArray(response.data?.fonts))
          {
           return {
                    code    : 1,
                    comment : `Polices récupérées (source: ${response.data.source ?? 'inconnue'}).`,
                    payload : response.data.fonts,
                  };
          }
     else {
           console.error('[getBroadcastingChannelMireFonts] réponse inattendue', response.status, response.data);
           return handleError<string[]>(-101, 'Erreur lors de la récupération des polices', []);
          }
   }
  catch (error)
   {
    console.error('[getBroadcastingChannelMireFonts] erreur réseau', error);
    return handleError<string[]>(-102, 'Network error', []);
   }
};

export interface BackendResponse_CheckExistence extends BackendResponse<boolean> {}

export const checkExistenceBroadcastingChannel = async (channelName: string): Promise<BackendResponse_CheckExistence> => {

  const url = `${API_URLS.checkExistenceBroadcastingChannel}?name=${channelName}`;

  const headers = {
    // 'User-Agent-Informations': `${userAgentInformations}`,
    // 'App-Informations': `${appInformations}`,
  };

  let result: BackendResponse_CheckExistence = {
    code    : 0,
    comment : 'Non traité',
    payload : false
  };

  try 
   {
    const response = await axios.get(url, { headers: headers });


    if (response.status === 200) 
	      {
	       if ( response.data.exist !== -1 )
	             {
                  result = {
                            code    : 1,
                            comment : response.data.comment,
                            payload : response.data.exist === 1
                           }; 
	             }
	        else {
                  result = handleError<boolean>(-103, `Erreur : ${response.data.comment}`);
                 }
          } 
	 else {
           result = handleError<boolean>(-101, `Erreur lors de la récupération des canaux de diffusion : ${response.status}`);
          }
   } 
  catch (error) 
   {
    result = handleError<boolean>(-102, 'Network error');
   }

  return result;
};


/**
 * Arrêt général de la diffusion (bouton « Panic » du menu super-admin).
 *
 * Équivalent de la commande `app:broadcasting:shutdown-all` : désactivation de toutes
 * les chaînes actives, puis les filets de sécurité — suppression des containers ffmpeg
 * restants, purge et redémarrage de MediaMTX, purge des routes HAProxy.
 *
 * L'appel est long (chaque chaîne est éteinte l'une après l'autre, MediaMTX redémarre) :
 * pas de timeout côté client, c'est l'API qui rend la main quand tout est fait.
 */
export interface PanicChannelResult {
  id     : number;
  uuid   : string;
  name   : string;
  status : 'success' | 'error';
  error ?: string;
}

export interface PanicReport {
  success       : boolean;
  message       : string;
  total         : number;
  deactivated   : number;
  errors        : number;
  channels      : PanicChannelResult[];
  containers    : { removed: number; failed: string[] };
  mediamtxState : 'restarted' | 'reloaded' | 'failed' | 'unknown';
  mediamtx      : string;
  haproxy       : string;
}

export const initializedPanicReport = (): PanicReport => ({
  success       : false,
  message       : '',
  total         : 0,
  deactivated   : 0,
  errors        : 0,
  channels      : [],
  containers    : { removed: 0, failed: [] },
  mediamtxState : 'unknown',
  mediamtx      : '',
  haproxy       : '',
});

export interface BackendResponse_PanicReport extends BackendResponse<PanicReport> {}

const describeHaproxyPurge = (haproxy: any): string => {
  if (!haproxy)                { return 'Purge HAProxy : aucun compte rendu.'; }
  if (haproxy.status !== 200)  { return `Purge HAProxy impossible : ${haproxy.error ?? 'erreur inconnue'}`; }

  const deleted = haproxy.deleted ?? 0;
  const failed  = haproxy.failed  ?? 0;

  return ( deleted === 0 && failed === 0 )
           ? 'Aucune route orpheline HAProxy.'
           : `Purge HAProxy : ${deleted} route(s) supprimée(s), ${failed} échec(s).`;
};

const describeMediaMtx = (mediamtx: any): string => {
  if (!mediamtx) { return 'MediaMTX : aucun compte rendu.'; }

  const purge = mediamtx.purge ?? {};

  const purgeText = ( purge.status !== 200 )
                      ? `purge impossible (${purge.error ?? 'erreur inconnue'})`
                      : ( (purge.deleted ?? 0) === 0 && (purge.failed ?? 0) === 0 )
                          ? 'aucun path orphelin'
                          : `${purge.deleted} path(s) purgé(s), ${purge.failed} échec(s)`;

  return `MediaMTX : ${purgeText}. ${mediamtx.message ?? ''}`.trim();
};

/**
 * L'arrêt tourne en arrière-plan côté API (~17 s par chaîne, trop long pour une seule
 * requête HTTP : Cloudflare coupe à 100 s). `panicShutdownAll…` le LANCE et rend la main
 * aussitôt ; `panicStatus…` en donne l'avancement, à sonder jusqu'à `done` / `failed`.
 */
export interface PanicJobState {
  status   : 'idle' | 'running' | 'done' | 'failed';
  phase    : string;
  startedAt: number;
  channels : PanicChannelResult[] | any[];
  report   : PanicReport | null;
  error    : string | null;
}

const toReport = (data: any): PanicReport => ({
  success       : data.success === true,
  message       : data.message ?? '',
  total         : data.deactivation?.total       ?? 0,
  deactivated   : data.deactivation?.deactivated ?? 0,
  errors        : data.deactivation?.errors      ?? 0,
  channels      : Array.isArray(data.deactivation?.channels) ? data.deactivation.channels : [],
  containers    : {
                   removed : data.containers?.removed ?? 0,
                   failed  : Array.isArray(data.containers?.failed) ? data.containers.failed : [],
                  },
  mediamtxState : data.mediamtx?.restart ?? 'unknown',
  mediamtx      : describeMediaMtx(data.mediamtx),
  haproxy       : describeHaproxyPurge(data.haproxy),
});

const toJobState = (data: any): PanicJobState => ({
  status    : data?.status ?? 'idle',
  phase     : data?.phase ?? '',
  startedAt : data?.startedAt ?? 0,
  channels  : Array.isArray(data?.channels) ? data.channels : [],
  report    : data?.report ? toReport(data.report) : null,
  error     : data?.error ?? null,
});

export interface BackendResponse_PanicJob extends BackendResponse<PanicJobState> {}

const initializedPanicJob = (): PanicJobState => toJobState({});

export const panicShutdownAllBroadcastingChannels = async (): Promise<BackendResponse_PanicJob> => {

  const url = `${API_URLS.panicShutdownAllBroadcastingChannels}`;

  console.log('[panicShutdownAll] POST', url);

  try
   {
    const response = await axios.post(url, {}, { validateStatus: status => status === 200 || status === 202 });

    console.log('[panicShutdownAll] lancé', response.status, response.data);

    return { code: 1, comment: '', payload: toJobState(response.data) };
   }
  catch (error)
   {
    console.error('[panicShutdownAll] erreur', error);
    return handleError<PanicJobState>(-102, "Le lancement de l'arrêt général a échoué (API injoignable ou erreur serveur)", initializedPanicJob());
   }
};

export const panicStatusBroadcastingChannels = async (): Promise<BackendResponse_PanicJob> => {

  try
   {
    const response = await axios.get(`${API_URLS.panicStatusBroadcastingChannels}`);

    return { code: 1, comment: '', payload: toJobState(response.data) };
   }
  catch (error)
   {
    return handleError<PanicJobState>(-102, "Statut de l'arrêt général indisponible", initializedPanicJob());
   }
};


export interface BackendResponse_EnrichedBroadcastingChannelList extends BackendResponse<EnrichedBroadcastingChannel[]> {}

export const getEnrichedBroadcastingChannelList = async (): Promise<BackendResponse_EnrichedBroadcastingChannelList> => {

  const medias = await retrieveMediaList({},[],true); // Assurez-vous que cette fonction retourne une promesse

  const channelsResponse = await getBroadcastingChannelList();

  if (channelsResponse.code !== 1) {
    return {
      code: channelsResponse.code,
      comment: channelsResponse.comment,
      payload: [],
    };
  }

  const channels = channelsResponse.payload;

  const enrichedChannels = channels.map((channel) => {
    const enrichedBroadcastedMedias: EnrichedBroadcastedMedia[] = channel.broadcastedMedias.map((media) => {
      const enrichedMedia = medias.find(m => m.id === media.mediaId) || initializedMedia();

      const durationStr = enrichedMedia.mediaType === 'Video'
                            ? (enrichedMedia as Video).duration
                            : (enrichedMedia as AudioSlideshow).imageDisplayDuration;

      return {
        ...initializedEnrichedBroadcastedMedia(),
        ...media,
        media: enrichedMedia,
        duration: convertTimeToSeconds(durationStr),
        title: enrichedMedia.name,
        thumbnail: enrichedMedia.thumbnail
      };
    });

    return {
      ...initializedEnrichedBroadcastingChannel(),
      ...channel,
      broadcastedMedias: enrichedBroadcastedMedias,
    };
  });

  return {
    code: 1,
    comment: 'Enriched broadcasting channels retrieval complete.',
    payload: enrichedChannels,
  };
};

// Interface pour la réponse de l'API avec un canal de diffusion enrichi
export interface BackendResponse_EnrichedBroadcastingChannel extends BackendResponse<EnrichedBroadcastingChannel> {}

// Fonction pour récupérer un canal de diffusion enrichi
export const getEnrichedBroadcastingChannel = async (broadcastingChannelId: number ): Promise<BackendResponse_EnrichedBroadcastingChannel> => {

  const medias = await retrieveMediaList( {},['AudioSlideshow','Video'], true); 

  const result = await getBroadcastingChannel (broadcastingChannelId)


  if ( result.code !== 1 )
   {
    return handleError<EnrichedBroadcastingChannel>(-101, 'Erreur lors de la récupération du canal enrichi');
   }

  const broadcastingChannel = result.payload

  const enrichedBroadcastedMedias: EnrichedBroadcastedMedia[] = [];

  /////
  
  // On appelle l'api pour être sûr d'avoir la liste à jour (même si ça a dû être modifié en mémoire...)
  
  // withArchives : un programme joué quitte aussitôt la liste (archivé par admin-api) ; sans
  // ses archives du jour, le bloc d'un « Lire maintenant » disparaissait dès sa fin.
  const getBroadcastedMediaListResponse = await getBroadcastedMediaList (broadcastingChannelId, undefined, undefined, true)
  
  
  const broadcastedMedias = getBroadcastedMediaListResponse.payload
  
  ////

  for (let i = 0; i < broadcastedMedias.length; i++) {
    const broadcastedMedia = broadcastedMedias[i];

    const enrichedMedia = medias.find(m => m.id === broadcastedMedia.mediaId) || initializedMedia();

	


    const durationStr = enrichedMedia.mediaType === 'Video'
                          ? (enrichedMedia as Video).duration
                          : (enrichedMedia as AudioSlideshow).imageDisplayDuration;


    enrichedBroadcastedMedias.push({
      ...broadcastedMedia,
      media: enrichedMedia,
      duration: convertTimeToSeconds(durationStr),
      title: enrichedMedia.name,
      thumbnail: enrichedMedia.thumbnail
    });
  }


  const enrichedChannel: EnrichedBroadcastingChannel = {
    ...broadcastingChannel,
    broadcastedMedias: keepPriorityArchives(enrichedBroadcastedMedias),
  };

  return {
    code: 1,
    comment: 'Enriched broadcasting channel retrieval complete.',
    payload: enrichedChannel,
  };
};


export const createBroadcastingChannel = async ( broadcastingChannel           : BroadcastingChannel ,
                                                 logoImageFileToUpload         : File | null         ,
									             pendingImageFileToUpload      : File | null         ,
									             pendingSoundFileToUpload      : File | null         ,
									             adminId?                      : number              ): Promise<BackendResponse> => {
											
  const associatedProductIdsStr : string = broadcastingChannel.associatedProductIds.join (',');
  const categoriesIdsStr        : string = broadcastingChannel.categoriesIds.join (',');
  const keywordsIdsStr          : string = broadcastingChannel.keywordsIds.join   (',');

  const url = `${API_URLS.createBroadcastingChannel}`;  // URL pour la création

  const formData = new FormData();


                                           formData.append ( 'active'                             , broadcastingChannel.active.toString()                             );
                                           formData.append ( 'name'                               , broadcastingChannel.name                                          );
                                           formData.append ( 'slug'                               , broadcastingChannel.slug                                          );
                                           formData.append ( 'description'                        , broadcastingChannel.description                                   );
                                           formData.append ( 'requiredUserStatusId'               , broadcastingChannel.requiredUserStatusId.toString()               );
                                           formData.append ( 'publicPortal'                       , broadcastingChannel.publicPortal.toString()                       );
  // Explicite : l'API défaut à ephemeral=true quand ce champ est absent, pour les
  // créations hors admin-front — une chaîne créée ici doit rester normale.
                                           formData.append ( 'ephemeral'                          , broadcastingChannel.ephemeral.toString()                          );
                                           // Sens du programme : fixé à la création, jamais modifié ensuite.
                                           formData.append ( 'orientation'                        , broadcastingChannel.orientation                                   );
                                           formData.append ( 'chatModeration'                     , broadcastingChannel.chatModeration.toString()                     );
                                           // Le chat choisi à la création : sans ce champ, admin-api laisse la chaîne chat fermé (les apps n'en envoient pas).
                                           formData.append ( 'chat'                               , broadcastingChannel.chatModeration !== -1 ? '1' : '0'            );
                                           // « Monter sur le plateau » ne vaut que pour une chaîne née ici : admin-api le retient
                                           // (BroadcastingChannel.createdFromRegie), les apps n'envoient pas ce champ (2026-10-15).
                                           formData.append ( 'origin'                             , 'regie'                                                           );
                                           formData.append ( 'stageOpen'                          , broadcastingChannel.stageOpen.toString()                          );
                                           formData.append ( 'ipTvGenericalUser'                  , broadcastingChannel.ipTvGenericalUser                       );
                                           formData.append ( 'ipTvGenericalPwd'                   , broadcastingChannel.ipTvGenericalPwd                       );
                                           formData.append ( 'mode'                               , broadcastingChannel.mode                                          );
                                           formData.append ( 'streamSource'                       , broadcastingChannel.streamSource                                  );
                                           formData.append ( 'showTitle'                          , broadcastingChannel.showTitle.toString()                          );
                                           formData.append ( 'showDate'                           , broadcastingChannel.showDate.toString()                           );
                                           formData.append ( 'titleFont'                          , broadcastingChannel.titleFont                                     );
                                           formData.append ( 'titleColor'                         , broadcastingChannel.titleColor                                    );
                                           formData.append ( 'titleX'                             , broadcastingChannel.titleX.toString()                             );
                                           formData.append ( 'titleY'                             , broadcastingChannel.titleY.toString()                             );
                                           formData.append ( 'titleSize'                          , broadcastingChannel.titleSize.toString()                          );
                                           formData.append ( 'titleBoxOpacity'                    , broadcastingChannel.titleBoxOpacity.toString()                    );
                                           formData.append ( 'dateBoxOpacity'                     , broadcastingChannel.dateBoxOpacity.toString()                     );
                                           formData.append ( 'titleBold'                          , broadcastingChannel.titleBold.toString()                          );
                                           formData.append ( 'titleUnderline'                     , broadcastingChannel.titleUnderline.toString()                     );
                                           formData.append ( 'titleItalic'                        , broadcastingChannel.titleItalic.toString()                        );
                                           formData.append ( 'dateFont'                           , broadcastingChannel.dateFont                                      );
                                           formData.append ( 'dateColor'                          , broadcastingChannel.dateColor                                     );
                                           formData.append ( 'dateX'                              , broadcastingChannel.dateX.toString()                              );
                                           formData.append ( 'dateY'                              , broadcastingChannel.dateY.toString()                              );
                                           formData.append ( 'dateSize'                           , broadcastingChannel.dateSize.toString()                          );
                                           formData.append ( 'dateBold'                           , broadcastingChannel.dateBold.toString()                           );
                                           formData.append ( 'dateUnderline'                      , broadcastingChannel.dateUnderline.toString()                      );
                                           formData.append ( 'dateItalic'                         , broadcastingChannel.dateItalic.toString()                         );
                                           formData.append ( 'timezone'                           , broadcastingChannel.timezone                                      );
  if (logoImageFileToUpload    !== null) { formData.append ( 'logoImageFileToUpload'              , logoImageFileToUpload                                             ); }
  if (pendingImageFileToUpload !== null) { formData.append ( 'pendingImageFileToUpload'           , pendingImageFileToUpload                                          ); }
  // Le son d'attente n'est PAS joint ici : il part par morceaux, en arrière-plan, une fois
  // la fiche enregistrée (voir uploadPendingSoundInBackground plus bas).
                                           formData.append ( 'categoriesIdsStr'                   , categoriesIdsStr                                                  );
                                           formData.append ( 'associatedProductIdsStr'            , associatedProductIdsStr                                           );
                                           formData.append ( 'keywordsIdsStr'                     , keywordsIdsStr                                                    );
                                           formData.append ( 'thirdPartyStreamingChannels.length' , broadcastingChannel.thirdPartyStreamingChannels.length.toString() );
  if (adminId)                            formData.append ( 'adminId'                            , adminId.toString()                                                );
									
  broadcastingChannel.thirdPartyStreamingChannels.forEach((thirdPartyStreamingChannel, index) => {
                                                 formData.append ( `thirdPartyStreamingChannel.${index}.active`                       , thirdPartyStreamingChannel.active.toString()             );
    if (thirdPartyStreamingChannel.name)         formData.append ( `thirdPartyStreamingChannel.${index}.name`                         , thirdPartyStreamingChannel.name                          );
    if (thirdPartyStreamingChannel.description)  formData.append ( `thirdPartyStreamingChannel.${index}.description`                  , thirdPartyStreamingChannel.description                   );
    if (thirdPartyStreamingChannel.ingestionKey) formData.append ( `thirdPartyStreamingChannel.${index}.ingestionKey`                 , thirdPartyStreamingChannel.ingestionKey                  );
    if (thirdPartyStreamingChannel.streamUrl)    formData.append ( `thirdPartyStreamingChannel.${index}.streamUrl`                    , thirdPartyStreamingChannel.streamUrl                     );
    if (thirdPartyStreamingChannel.backupUrl)    formData.append ( `thirdPartyStreamingChannel.${index}.backupUrl`                    , thirdPartyStreamingChannel.backupUrl                     );
                                                 formData.append ( `thirdPartyStreamingChannel.${index}.thirdPartyStreamingServiceId` , thirdPartyStreamingChannel.thirdPartyStreamingServiceId.toString()  );
  });

  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'multipart/form-data',
  };

  try
   {
    const response = await axios.post(url, formData, { headers });  // Utilisation de POST pour la création

    if (response.status === 201)
          {  // Création réussie, code 201
           const createdChannel = response.data as BroadcastingChannel;

           if ( pendingSoundFileToUpload !== null ) { uploadPendingSoundInBackground ( createdChannel.id , pendingSoundFileToUpload ); }

           return {
                    code    : 1,
                    comment : 'Broadcasting channel created successfully.',
                    payload : createdChannel,
                  };
          }
     else {
           return handleError<BroadcastingChannel>(response.status, 'Error creating the broadcasting channel');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      // Le 409 de la création est un refus motivé — quota de chaînes atteint —, et son
      // `detail` porte la phrase à afficher. Le confondre avec une erreur technique ferait
      // dire « une erreur est survenue » là où il faut expliquer ce qui bloque.
      if (error.response?.status === 409)
       {
        return handleError<BroadcastingChannel>(409, error.response?.data?.detail ?? 'Quota de chaînes atteint.');
       }

      return handleError<BroadcastingChannel>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<BroadcastingChannel>(-102, 'Unknown error');
   }
};


export const deleteBroadcastingChannel = async (id: number): Promise<BackendResponse> => {
  const baseUrl = `${API_URLS.deleteBroadcastingChannel}`;
  const url = baseUrl.replace('{id}', `${id}`);  // Remplacement de l'ID dans l'URL

  try
   {
    const response = await axios.delete(url);  // Requête DELETE pour supprimer le canal

    if (response.status === 204 || response.status === 200) {  // Suppression réussie, sans contenu retourné
      return {
        code: 1,
        comment: 'The broadcasting channel has been successfully deleted.',
        payload: undefined,
      };
    }

    if (response.status === 409) {  // Suppression réussie, sans contenu retourné
      return {
        code    : -103,
        comment : 'The broadcasting channel is linked with other entities.',
        payload : {} as any
      };
    }

    else {
      return handleError<void>(response.status, 'Error deleting the broadcasting channel');
    }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<void>(-102, 'Unknown error');
   }
};

  // Interface pour la réponse de l'API avec une liste de chaînes de diffusion
export interface BackendResponse_BroadcastingChannel extends BackendResponse<BroadcastingChannel> {}


export const updateBroadcastingChannel = async ( broadcastingChannel           : BroadcastingChannel ,
                                                 logoImageFileToUpload         : File | null         ,
									             pendingImageFileToUpload      : File | null         ,
									             pendingSoundFileToUpload      : File | null         ,
												 logoImageMarkedForDeleting    : boolean             ,
												 pendingImageMarkedForDeleting : boolean             ,
												 pendingSoundMarkedForDeleting : boolean             ,
												 adminId?                      : number              ): Promise<BackendResponse_BroadcastingChannel> => {

  const associatedProductIdsStr : string = broadcastingChannel.associatedProductIds.join (',');
  const categoriesIdsStr        : string = broadcastingChannel.categoriesIds.join (',');
  const keywordsIdsStr          : string = broadcastingChannel.keywordsIds.join   (',');

  const url = `${API_URLS.patchBroadcastingChannel}`;
 // const url = baseUrl.replace('{id}', `${broadcastingChannel.id}`);  // Remplacement de l'ID dans l'URL

  const formData = new FormData();
  
                                           formData.append ( 'id'                                 , broadcastingChannel.id.toString()                             );
                                           formData.append ( 'uuid'                               , broadcastingChannel.uuid                             );
                                           formData.append ( 'active'                             , broadcastingChannel.active.toString()                             );
                                           formData.append ( 'name'                               , broadcastingChannel.name                                          );
                                           formData.append ( 'slug'                               , broadcastingChannel.slug                                          );
                                           formData.append ( 'description'                        , broadcastingChannel.description                                   );
                                           formData.append ( 'requiredUserStatusId'               , broadcastingChannel.requiredUserStatusId.toString()               );
                                           formData.append ( 'publicPortal'                       , broadcastingChannel.publicPortal.toString()                       );
                                           // Sens du programme : le serveur refuse (409) un changement tant que la chaîne est active.
                                           formData.append ( 'orientation'                        , broadcastingChannel.orientation                                   );
                                           formData.append ( 'chatModeration'                     , broadcastingChannel.chatModeration.toString()                     );
                                           // Sans effet côté serveur sur une chaîne qui n'est pas née dans la régie web.
                                           formData.append ( 'stageOpen'                          , broadcastingChannel.stageOpen.toString()                          );
                                           formData.append ( 'ipTvGenericalUser'                  , broadcastingChannel.ipTvGenericalUser                       );
                                           formData.append ( 'ipTvGenericalPwd'                   , broadcastingChannel.ipTvGenericalPwd                       );
                                           formData.append ( 'mode'                               , broadcastingChannel.mode                                          );
                                           formData.append ( 'streamSource'                       , broadcastingChannel.streamSource                                  );
										   formData.append ( 'showTitle'                          , broadcastingChannel.showTitle.toString()                          );
                                           formData.append ( 'showDate'                           , broadcastingChannel.showDate.toString()                           );
                                           formData.append ( 'titleFont'                          , broadcastingChannel.titleFont                                     );
                                           formData.append ( 'titleColor'                         , broadcastingChannel.titleColor                                    );
                                           formData.append ( 'titleX'                             , broadcastingChannel.titleX.toString()                             );
                                           formData.append ( 'titleY'                             , broadcastingChannel.titleY.toString()                             );
                                           formData.append ( 'titleSize'                          , broadcastingChannel.titleSize.toString()                          );
                                           formData.append ( 'titleBoxOpacity'                    , broadcastingChannel.titleBoxOpacity.toString()                    );
                                           formData.append ( 'dateBoxOpacity'                     , broadcastingChannel.dateBoxOpacity.toString()                     );
                                           formData.append ( 'titleBold'                          , broadcastingChannel.titleBold.toString()                          );
                                           formData.append ( 'titleUnderline'                     , broadcastingChannel.titleUnderline.toString()                     );
                                           formData.append ( 'titleItalic'                        , broadcastingChannel.titleItalic.toString()                        );
                                           formData.append ( 'dateFont'                           , broadcastingChannel.dateFont                                      );
                                           formData.append ( 'dateColor'                          , broadcastingChannel.dateColor                                     );
                                           formData.append ( 'dateX'                              , broadcastingChannel.dateX.toString()                              );
                                           formData.append ( 'dateY'                              , broadcastingChannel.dateY.toString()                              );
                                           formData.append ( 'dateSize'                           , broadcastingChannel.dateSize.toString()                           );
                                           formData.append ( 'dateBold'                           , broadcastingChannel.dateBold.toString()                           );
                                           formData.append ( 'dateUnderline'                      , broadcastingChannel.dateUnderline.toString()                      );
                                           formData.append ( 'dateItalic'                         , broadcastingChannel.dateItalic.toString()                         );
                                           formData.append ( 'timezone'                          , broadcastingChannel.timezone                                      );

  if (logoImageFileToUpload    !== null) { formData.append ( 'logoImageFileToUpload'              , logoImageFileToUpload                                             ); }
  if (pendingImageFileToUpload !== null) { formData.append ( 'pendingImageFileToUpload'           , pendingImageFileToUpload                                          ); }
  // Le son d'attente n'est PAS joint ici : il part par morceaux, en arrière-plan, une fois
  // la fiche enregistrée (voir uploadPendingSoundInBackground plus haut).
                                           formData.append ( 'logoImageMarkedForDeleting'         , logoImageMarkedForDeleting.toString()             );
                                           formData.append ( 'pendingImageMarkedForDeleting'      , pendingImageMarkedForDeleting.toString());
                                           formData.append ( 'pendingSoundMarkedForDeleting'      , pendingSoundMarkedForDeleting.toString());
                                           formData.append ( 'categoriesIdsStr'                   , categoriesIdsStr                                                  );
                                           formData.append ( 'associatedProductIdsStr'            , associatedProductIdsStr                                           );
                                           formData.append ( 'keywordsIdsStr'                     , keywordsIdsStr                                                    );
                                           formData.append ( 'thirdPartyStreamingChannels.length' , broadcastingChannel.thirdPartyStreamingChannels.length.toString() );

  if (adminId)                            formData.append ( 'adminId'                            , adminId.toString()                                                );

  broadcastingChannel.thirdPartyStreamingChannels.forEach((thirdPartyStreamingChannel, index) => {
                                                 formData.append ( `thirdPartyStreamingChannel.${index}.id`                           , thirdPartyStreamingChannel.id.toString()                            );
                                                 formData.append ( `thirdPartyStreamingChannel.${index}.active`                       , thirdPartyStreamingChannel.active.toString()             );
    if (thirdPartyStreamingChannel.name)         formData.append ( `thirdPartyStreamingChannel.${index}.name`                         , thirdPartyStreamingChannel.name                          );
    if (thirdPartyStreamingChannel.description)  formData.append ( `thirdPartyStreamingChannel.${index}.description`                  , thirdPartyStreamingChannel.description                   );
    if (thirdPartyStreamingChannel.ingestionKey) formData.append ( `thirdPartyStreamingChannel.${index}.ingestionKey`                 , thirdPartyStreamingChannel.ingestionKey                  );
    if (thirdPartyStreamingChannel.streamUrl)    formData.append ( `thirdPartyStreamingChannel.${index}.streamUrl`                    , thirdPartyStreamingChannel.streamUrl                      );
    if (thirdPartyStreamingChannel.backupUrl)    formData.append ( `thirdPartyStreamingChannel.${index}.backupUrl`                    , thirdPartyStreamingChannel.backupUrl                      );
                                                 formData.append ( `thirdPartyStreamingChannel.${index}.broadcastingChannelId`        , thirdPartyStreamingChannel.broadcastingChannelId.toString()         );
                                                 formData.append ( `thirdPartyStreamingChannel.${index}.thirdPartyStreamingServiceId` , thirdPartyStreamingChannel.thirdPartyStreamingServiceId.toString()  );
  });

  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'multipart/form-data',
  };

  try
   {
    const response = await axios.post(url, formData, { headers });  // Patch ne fonctionne pas avec un formdata

    if (response.status === 200 || response.status === 204 || response.status === 201)
          {
           if ( pendingSoundFileToUpload !== null ) { uploadPendingSoundInBackground ( broadcastingChannel.id , pendingSoundFileToUpload ); }

           return {
                    code    : 1,
                    comment : 'Broadcasting channel updated successfully.',
                    payload : response.data as BroadcastingChannel,
                  };
          }
     else {
           return handleError<BroadcastingChannel>(response.status, 'Error updating the broadcasting channel');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      if (error.response?.status === 409)
       {
        return handleError<BroadcastingChannel>(409, 'Slug déjà utilisé par une autre chaîne');
       }
      return handleError<BroadcastingChannel>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<BroadcastingChannel>(-102, 'Unknown error');
   }
};



export const updateBroadcastingChannelVisibility = async (id: number, visibility: boolean): Promise<BackendResponse<void>> => {

  /*
  const baseUrl = `${API_URLS.patchBroadcastingChannelVisibility}`;
  const url = baseUrl.replace('{id}', `${id}`);  // Remplacement de l'ID dans l'URL
  const visibilityStr = visibility ? 'true' : 'false';
  */

  const baseUrl = visibility
                    ? `${API_URLS.activateBroadcastingChannelInternalStreamingService}`
                    : `${API_URLS.desactivateBroadcastingChannelInternalStreamingService}`;

  const url = baseUrl.replace('{id}', `${id}`);


  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'application/merge-patch+json',
  };

  try {
 //   const response = await axios.patch(url, { visibility: visibilityStr }, { headers });

    const response = await axios.patch(url, {}, { headers });

    if (response.status === 200 || response.status === 204) {  // Mise à jour réussie
      return {
        code: 1,
        comment: 'Broadcasting channel visibility updated successfully.',
        payload: undefined,
      };
    } else {
      return handleError<void>(response.status, 'Error updating the broadcasting channel visibility');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Le 409 renvoyé par l'activation (quota de chaînes actives atteint) doit rester
      // distinguable d'une panne réseau : l'appelant en fait un message dédié.
      if (error.response?.status === 409) {
        return handleError<void>(409, error.response?.data?.detail ?? 'Quota de chaînes actives atteint');
      }

      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }

    return handleError<void>(-102, 'Network error');
  }
};

export const updateBroadcastingChannelPublicPortal = async (id: number, publicPortal: boolean): Promise<BackendResponse<void>> => {

  const baseUrl = publicPortal
    ? `${API_URLS.showBroadcastingChannelOnPublicPortal}`
    : `${API_URLS.hideBroadcastingChannelFromPublicPortal}`;
  const url     = baseUrl.replace('{id}', `${id}`);

  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'application/merge-patch+json',
  };

  try {
    const response = await axios.patch(url, {}, { headers });

    if (response.status === 200 || response.status === 204) {
      return {
        code: 1,
        comment: 'Broadcasting channel public portal updated successfully.',
        payload: undefined,
      };
    } else {
      return handleError<void>(response.status, 'Error updating the broadcasting channel public portal');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<void>(-102, 'Network error');
  }
};

export interface BroadcastingChannelMetricsStatus {
  enabled   : boolean;
  reachable : boolean;
}

// enabled=false/reachable=false : soit désactivé, soit chaîne inactive
// (container ffmpeg-microservice arrêté, donc système de mesure non
// interrogeable) — les deux cas s'affichent de la même façon côté UI.
export const getBroadcastingChannelMetricsStatus = async (id: number): Promise<BackendResponse<BroadcastingChannelMetricsStatus>> => {

  const url = API_URLS.getBroadcastingChannelMetricsStatus.replace('{id}', `${id}`);

  try {
    const response = await axios.get(url, { headers: { 'Accept': 'application/ld+json' } });

    if (response.status === 200) {
      const data = response.data;
      return {
        code: 1,
        comment: 'Broadcasting channel metrics status retrieved successfully.',
        payload: {
          enabled   : data.enabled   ?? false,
          reachable : data.reachable ?? false,
        },
      };
    } else {
      return handleError<BroadcastingChannelMetricsStatus>(response.status, 'Error retrieving the broadcasting channel metrics status');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<BroadcastingChannelMetricsStatus>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<BroadcastingChannelMetricsStatus>(-102, 'Network error');
  }
};

export const updateBroadcastingChannelMetrics = async (id: number, enabled: boolean): Promise<BackendResponse<BroadcastingChannelMetricsStatus>> => {

  const baseUrl = enabled
    ? `${API_URLS.startBroadcastingChannelMetrics}`
    : `${API_URLS.stopBroadcastingChannelMetrics}`;
  const url     = baseUrl.replace('{id}', `${id}`);

  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'application/merge-patch+json',
  };

  try {
    const response = await axios.patch(url, {}, { headers });

    if (response.status === 200 || response.status === 204) {
      const data = response.data ?? {};
      return {
        code: 1,
        comment: 'Broadcasting channel metrics updated successfully.',
        payload: {
          enabled   : data.enabled   ?? enabled,
          reachable : data.reachable ?? false,
        },
      };
    } else {
      return handleError<BroadcastingChannelMetricsStatus>(response.status, 'Error updating the broadcasting channel metrics');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<BroadcastingChannelMetricsStatus>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<BroadcastingChannelMetricsStatus>(-102, 'Network error');
  }
};

export const activateInternalStreamingService = async ( channelId : number ): Promise<BackendResponse_BroadcastingChannel> => {

  const baseUrl = `${API_URLS.activateBroadcastingChannelInternalStreamingService}`;
  const url     = baseUrl.replace('{id}', `${channelId}`);

  try
   {
    const response = await axios.patch(url, {} );

    if (response.status === 200)
          {
           return {
                    code    : 1,
                    comment : 'The streaming channel active status has been updated successfully.',
                    payload : response.data,
                  };
          }
     else {
           return handleError<BroadcastingChannel>(response.status, 'Non-200 response from API');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<BroadcastingChannel>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<BroadcastingChannel>(-102, 'Unknown error');
   }
};

export interface RtmpCredentials { rtmpLogin: string; rtmpPassword: string; pushed: boolean }

/**
 * Régénère le login / mot de passe RTMP (clé d'OBS) d'une chaîne. Si la chaîne est allumée,
 * l'API les pousse au microservice MediaMTX AVANT d'écrire en base : en cas d'échec rien
 * n'est modifié et `comment` dit pourquoi.
 */
export const regenerateRtmpCredentials = async ( channelId : number ): Promise<BackendResponse<RtmpCredentials>> => {

  const url = `${API_URLS.regenerateBroadcastingChannelRtmpCredentials}`.replace('{id}', `${channelId}`);

  try
   {
    const response = await axios.post(url, {});

    return { code: 1, comment: '', payload: response.data };
   }
  catch (error: any)
   {
    const detail = error?.response?.data?.error;
    console.error('[regenerateRtmpCredentials] erreur', error);
    return handleError<RtmpCredentials>(-103, detail ?? 'La régénération de la clé a échoué (API injoignable ou erreur serveur).', { rtmpLogin: '', rtmpPassword: '', pushed: false });
   }
};

export const desactivateInternalStreamingService = async ( channelId : number ): Promise<BackendResponse_BroadcastingChannel> => {

  const baseUrl = `${API_URLS.desactivateBroadcastingChannelInternalStreamingService}`;
  const url     = baseUrl.replace('{id}', `${channelId}`);

  try
   {
    const response = await axios.patch(url, {} );

    if (response.status === 200)
          {
           return {
                    code    : 1,
                    comment : 'The streaming channel active status has been updated successfully.',
                    payload : response.data,
                  };
          }
     else {
           return handleError<BroadcastingChannel>(response.status, 'Non-200 response from API');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      if (error.response?.status === 409)
       {
        return handleError<BroadcastingChannel>(409, 'Quota de chaînes de diffusion atteint');
       }
      return handleError<BroadcastingChannel>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<BroadcastingChannel>(-102, 'Unknown error');
   }
};


export const updateBroadcastingChannelLiveToggle = async (id: number, visibility: boolean): Promise<BackendResponse<void>> => {

  /*
  const baseUrl = `${API_URLS.patchBroadcastingChannelVisibility}`;
  const url = baseUrl.replace('{id}', `${id}`);  // Remplacement de l'ID dans l'URL
  const visibilityStr = visibility ? 'true' : 'false';
  */

  const baseUrl = API_URLS.toggleBroadcastingChannelLiveService

  const url = baseUrl.replace('{id}', `${id}`) + "?liveActivate=" + (visibility?"true":"false");


  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'application/merge-patch+json',
  };

  try {
 //   const response = await axios.patch(url, { visibility: visibilityStr }, { headers });

    const response = await axios.patch(url, {}, { headers });

    if (response.status === 200 || response.status === 204) {  // Mise à jour réussie
      return {
        code: 1,
        comment: 'Broadcasting channel visibility updated successfully.',
        payload: undefined,
      };
    } else {
      return handleError<void>(response.status, 'Error updating the broadcasting channel visibility');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }

    return handleError<void>(-102, 'Network error');
  }
};


export const updateBroadcastingChannelStreamSource = async (id: number, streamSource: string): Promise<BackendResponse<void>> => {

  /*
  const baseUrl = `${API_URLS.patchBroadcastingChannelVisibility}`;
  const url = baseUrl.replace('{id}', `${id}`);  // Remplacement de l'ID dans l'URL
  const visibilityStr = visibility ? 'true' : 'false';
  */

  const baseUrl = API_URLS.toggleBroadcastingChannelStreamSource

  const url = baseUrl.replace('{id}', `${id}`) + "?streamSource=" + streamSource;


  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'application/merge-patch+json',
  };

  try {
 //   const response = await axios.patch(url, { visibility: visibilityStr }, { headers });

    const response = await axios.patch(url, {}, { headers });

    if (response.status === 200 || response.status === 204) {  // Mise à jour réussie
      return {
        code: 1,
        comment: 'Broadcasting channel stream source updated successfully.',
        payload: undefined,
      };
    } else {
      return handleError<void>(response.status, 'Error updating the broadcasting channel visibility');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }

    return handleError<void>(-102, 'Network error');
  }
};



/**
 * Sauvegarde le mapping "numéro d'angle public ↔ path MediaMTX" d'une chaîne en
 * multiview (voir BroadcastingChannelMultiviewAngles côté admin-api). `angles` vide
 * retire toute exposition publique des angles de cette chaîne.
 */
export const updateBroadcastingChannelMultiviewAngles = async (
  id: number,
  angles: { n: number; path: string; label?: string }[],
): Promise<BackendResponse<void>> => {

  const url = API_URLS.updateBroadcastingChannelMultiviewAngles.replace('{id}', `${id}`);

  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'application/json',
  };

  try {
    const response = await axios.patch(url, { angles }, { headers });

    if (response.status === 200 || response.status === 204) {
      return {
        code: 1,
        comment: 'Broadcasting channel multiview angles updated successfully.',
        payload: undefined,
      };
    } else {
      return handleError<void>(response.status, 'Error updating the broadcasting channel multiview angles');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }

    return handleError<void>(-102, 'Network error');
  }
};

export const updateBroadcastingChannelMultiview = async (id: number, multiview: boolean): Promise<BackendResponse<void>> => {

  const baseUrl = API_URLS.toggleBroadcastingChannelMultiview

  const url = baseUrl.replace('{id}', `${id}`) + "?multiview=" + (multiview ? 'true' : 'false');

  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'application/merge-patch+json',
  };

  try {
    const response = await axios.patch(url, {}, { headers });

    if (response.status === 200 || response.status === 204) {
      return {
        code: 1,
        comment: 'Broadcasting channel multiview updated successfully.',
        payload: undefined,
      };
    } else {
      return handleError<void>(response.status, 'Error updating the broadcasting channel multiview');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }

    return handleError<void>(-102, 'Network error');
  }
};



export const getBroadcastingChannelById = async (broadcastingChannelId: number, detailled: boolean= false): Promise<BackendResponse_BroadcastingChannel> => {

  if ( broadcastingChannelId === 0 || isNaN (broadcastingChannelId) )
   {
    return handleError<BroadcastingChannel>(-104, `broadcastingChannelId incorrect`);

  }

  const baseUrl = API_URLS.getBroadcastingChannel;
  const url = baseUrl.replace('{id}', `${broadcastingChannelId}`);

  console.log ("getBroadcastingChannelById ", url)

  try
   {
    const response = await axios.get(url);

    console.log ("getBroadcastingChannelById ", response)

    if (response.status === 200)
          {
             const defaultBroadcastingChannel = initializedBroadcastingChannel();

             const broadcastingChannel : BroadcastingChannel = {
               ...defaultBroadcastingChannel,
               id                          : response.data.id                   ?? 0     ,    
		       uuid                        : response.data.uuid                 ?? ''    ,
		       publicRef                   : response.data.publicRef                 ?? ''    ,
		       rtmpLogin                   : response.data.rtmpLogin            ?? undefined ,
		       rtmpPassword                : response.data.rtmpPassword         ?? undefined ,
			   creationDate                : response.data.creationDate         ?? null  ,
		       name                        : response.data.name                 ?? ''    ,
		       slug                        : response.data.slug                 ?? ''    ,
               active                      : response.data.active               ?? false ,
               channelStatus               : response.data.channelStatus        ?? (response.data.active ? 'active' : 'inactive') ,
               activeScheduled             : response.data.activeScheduled      ?? false     ,     
               activeStartDate             : response.data.activeStartDate      ?? null ,     // Si non nul alors actif après cette date, sinon actif/inactif immédiatement
               activeEndDate               : response.data.activeEndDate        ?? null ,     // Si non nul alors actif après cette date, sinon actif/inactif immédiatement
               publicPortal                : response.data.publicPortal         ?? false,
               ephemeral                   : response.data.ephemeral            ?? false,
               orientation                : response.data.orientation === 'portrait' ? 'portrait' : 'landscape',
              videoProfile               : response.data.videoProfile ?? undefined,
               multiview                   : response.data.multiview            ?? false,
               ownerId                     : response.data.ownerId              ?? null,
               ownerUseFiligrane           : response.data.ownerUseFiligrane    ?? false,
               chatModeration              : response.data.chatModeration       ?? 0     ,
               createdFromRegie            : response.data.createdFromRegie     ?? false ,
               stageOpen                   : response.data.stageOpen            ?? false ,
               mode                        : response.data.mode                 ?? ''    ,
               streamSource                : response.data.streamSource         ?? ''    ,
          
               logoImageFile               : response.data.logoImageFile        ?? ''    ,
               pendingImageFile            : response.data.pendingImageFile     ?? ''    ,
               pendingSoundFile            : response.data.pendingSoundFile     ?? ''    ,
		       description                 : response.data.description          ?? ''    ,
		  
		       requiredUserStatusId        : response.data.requiredUserStatusId ?? -1    ,
		  
               keywordsIds                 : detailled ? (response.data.keywordsIds?.map((keyword: any) => keyword.id) || [])  : [],
               categoriesIds               : detailled ? (response.data.broadcastingChannelCategories?.map((category: any) => category.id) || [])  : [],
               associatedProductIds        : detailled ? (response.data.associatedProductIds?.map((product: any) => product.id) || []) : [],
  
  
               thirdPartyStreamingChannels : detailled ? ( mapThirdPartyStreamingChannels(response.data.thirdPartyStreamingChannels ?? [])) : [],

               ingestionUrl                : '',
               watchingUrl                 : response.data.watchingUrl ? response.data.watchingUrl : ( response.data.name ? `https://${WWW_DOMAIN}/${generateSlug(response.data.name)}/stream.m3u8` : '' ) ,

          // `rtsp://${WWW_DOMAIN}/${generateSlug(initialBroadcastingChannel.name)}`
          // `https://${WWW_DOMAIN}/${generateSlug(initialBroadcastingChannel.name)}/stream.m3u8`

                        ipTvGenericalUser              : response.data.ipTvGenericalUser ?? '',
              ipTvGenericalPwd               : response.data.ipTvGenericalPwd ?? '',  


               currentBroadcastedMediaId   : response.data.currentBroadcastedMediaId   ?? 0  ,
               currentBroadcastedMediaName : response.data.currentBroadcastedMediaName ?? '' ,
               currentNumberOfConnections  : response.data.currentNumberOfConnections  ?? 0  ,
               broadcastedMedias           : detailled ? (response.data.broadcastedMedias ? parseBroadcastedMedias(response.data.broadcastedMedias) : []) : [],
             };

           return {
                    code    : 1,
                    comment : 'The retrieval of broadcasting channel is complete.',
                    payload : broadcastingChannel,
                  };
          }
     else {
           return handleError<BroadcastingChannel>(response.status, 'Non-200 response from API');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<BroadcastingChannel>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<BroadcastingChannel>(-102, 'Unknown error');
  }}



export interface CurrentAndNextMediaPayload {
  current: EnrichedBroadcastedMedia | null;
  next: EnrichedBroadcastedMedia | null;
}

export interface BackendResponse_CurrentAndNextMedia extends BackendResponse<CurrentAndNextMediaPayload> {
  hash?: string;
  hasChanged?: boolean;
}

/**
 * Récupère uniquement les 2 médias critiques : celui en cours et le suivant
 * Optimisé pour le polling avec détection de changement par hash
 */
export const getCurrentAndNextBroadcastedMedias = async (
  channelId: number,
  previousHash?: string
): Promise<BackendResponse_CurrentAndNextMedia> => {
  
  const baseUrl = `${API_URLS.getCurrentAndNextBroadcastedMedias}`;
  const url = baseUrl.replace('{id}', `${channelId}`);

  const headers = {
    'Accept': 'application/ld+json',
  };

  try {
    const response = await axios.get(url, { headers });

    if (response.status === 200) {
      const newHash = response.data.hash;
      const hasChanged = !previousHash || previousHash !== newHash;

      // Si rien n'a changé, retourner rapidement sans enrichir
      if (!hasChanged) {
        console.log('Polling: aucun changement détecté (hash identique)');
        return {
          code: 1,
          comment: 'No changes detected.',
          payload: { current: null, next: null },
          hash: newHash,
          hasChanged: false,
        };
      }

      console.log('Polling: changements détectés, enrichissement des médias...');

      // Enrichir les médias seulement si changement détecté
      const medias = await retrieveMediaList({}, ['AudioSlideshow', 'Video'], true);

      const enrichMedia = (mediaData: any): EnrichedBroadcastedMedia | null => {
        if (!mediaData) return null;

        const enrichedMedia = medias.find(m => m.id === mediaData.mediaId) || initializedMedia();
        
        const durationStr = enrichedMedia.mediaType === 'Video'
          ? (enrichedMedia as Video).duration
          : (enrichedMedia as AudioSlideshow).imageDisplayDuration;

        return {
          ...initializedEnrichedBroadcastedMedia(),
          id: mediaData.id,
          mediaId: mediaData.mediaId,
          broadcastDate: mediaData.broadcastDate ? new Date(mediaData.broadcastDate) : null,
          status: mediaData.status,
          actualStartTime: mediaData.actualStartTime ? new Date(mediaData.actualStartTime) : null,
          media: enrichedMedia,
          duration: convertTimeToSeconds(durationStr),
          title: enrichedMedia.name,
          thumbnail: enrichedMedia.thumbnail,
        };
      };

      return {
        code: 1,
        comment: 'Current and next media retrieved successfully.',
        payload: {
          current: enrichMedia(response.data.current),
          next: enrichMedia(response.data.next),
        },
        hash: newHash,
        hasChanged: true,
      };
    } else {
      return handleError<CurrentAndNextMediaPayload>(-101, `HTTP error: ${response.status}`);
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<CurrentAndNextMediaPayload>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<CurrentAndNextMediaPayload>(-102, 'Unknown error');
  }
};

export interface BackendResponse_XtreamConnectionCount extends BackendResponse<XtreamConnectionCount> {}

/**
 * Nombre de viewers Xtream connectés à une chaîne : connexions actives récentes
 * (fenêtre glissante, cf. XtreamConnectionLog côté API) + total historique.
 */
export const getXtreamConnectionCount = async (channelId: number): Promise<BackendResponse_XtreamConnectionCount> => {

  const url = API_URLS.getXtreamConnectionCount.replace('{id}', `${channelId}`);

  try {
    const response = await axios.get(url, { headers: { 'Accept': 'application/ld+json' } });

    if (response.status === 200) {
      const data = response.data;

      return {
        code: 1,
        comment: 'Xtream connection count retrieved successfully.',
        payload: {
          ...initializedXtreamConnectionCount(),
          channelId         : data.channelId         ?? channelId,
          activeConnections : data.activeConnections ?? 0,
          windowSeconds     : data.windowSeconds      ?? 60,
          totalConnections  : data.totalConnections   ?? 0,
          lastConnectionAt  : data.lastConnectionAt ? new Date(data.lastConnectionAt) : null,
        },
      };
    } else {
      return handleError<XtreamConnectionCount>(-101, `HTTP error: ${response.status}`);
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<XtreamConnectionCount>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<XtreamConnectionCount>(-102, 'Unknown error');
  }
};

export interface BackendResponse_XtreamConnectionLocations extends BackendResponse<XtreamConnectionLocations> {}

/**
 * Connexions Xtream actives géolocalisées, pour affichage sur une carte.
 */
export const getXtreamConnectionLocations = async (channelId: number): Promise<BackendResponse_XtreamConnectionLocations> => {

  const url = API_URLS.getXtreamConnectionLocations.replace('{id}', `${channelId}`);

  try {
    const response = await axios.get(url, { headers: { 'Accept': 'application/ld+json' } });

    if (response.status === 200) {
      const data = response.data;

      return {
        code: 1,
        comment: 'Xtream connection locations retrieved successfully.',
        payload: {
          ...initializedXtreamConnectionLocations(),
          channelId     : data.channelId     ?? channelId,
          windowSeconds : data.windowSeconds  ?? 60,
          count         : data.count          ?? 0,
          locations     : (data.locations ?? []).map((location: any) => ({
            username       : location.username       ?? '',
            ipAddress      : location.ipAddress       ?? '',
            lat            : location.lat             ?? 0,
            lon            : location.lon             ?? 0,
            city           : location.city            ?? null,
            country        : location.country         ?? null,
            isp            : location.isp             ?? null,
            connectionDate : location.connectionDate ? new Date(location.connectionDate) : null,
          })),
        },
      };
    } else {
      return handleError<XtreamConnectionLocations>(-101, `HTTP error: ${response.status}`);
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<XtreamConnectionLocations>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<XtreamConnectionLocations>(-102, 'Unknown error');
  }
};

  export const getThumbnailImageUrl = (initialBroadcastingChannel : EnrichedBroadcastingChannel): string => {
    
    if ( initialBroadcastingChannel.uuid && initialBroadcastingChannel.uuid !== '' ) 
       {
        if ( initialBroadcastingChannel.logoImageFile && initialBroadcastingChannel.logoImageFile !== '' )
         {
             return `${WWW_URLS.MediaServer}${initialBroadcastingChannel.publicRef}/images/thumbnail.webp`
         }
       }
    
      return''
  }
  export const getLogoImageUrl = (initialBroadcastingChannel : EnrichedBroadcastingChannel): string => {
    
    if ( initialBroadcastingChannel.uuid && initialBroadcastingChannel.uuid !== '' ) 
       {
        if ( initialBroadcastingChannel.logoImageFile && initialBroadcastingChannel.logoImageFile !== '' )
         {
             return `${WWW_URLS.MediaServer}${initialBroadcastingChannel.publicRef}/images/logo.webp`
         }
       }
    
      return''
  }
  
  export const getPendingImageUrl = (initialBroadcastingChannel : EnrichedBroadcastingChannel): string => {
    
    if ( initialBroadcastingChannel.uuid && initialBroadcastingChannel.uuid !== '' ) 
       {
        if ( initialBroadcastingChannel.pendingImageFile && initialBroadcastingChannel.pendingImageFile !== '' )
         {
            return `${WWW_URLS.MediaServer}${initialBroadcastingChannel.publicRef}/images/pending.webp`
         }
       }
    
      return''
  }

  export const getPendingSoundUrl = (broadcastingChannel : EnrichedBroadcastingChannel): string => {
    
    if ( broadcastingChannel.uuid && broadcastingChannel.uuid !== '' ) 
       {
        if ( broadcastingChannel.pendingSoundFile && broadcastingChannel.pendingSoundFile !== '' )
         {
            return `${WWW_URLS.MediaServer}${broadcastingChannel.publicRef}/sounds/pending.aac`
         }
       }
    
      return''
  }

  /**
   * ⚠️ RTSP et RTMP (ci-dessous) gardent l'UUID, et ce n'est pas un oubli.
   *
   * HAProxy les relaie en TCP BRUT : il n'y a pas de chemin HTTP à réécrire,
   * donc pas de traduction possible. L'uuid y est le seul nom que MediaMTX
   * connaisse. Les remplacer par la référence rendrait ces adresses injoignables.
   *
   * La règle n'est donc pas « la référence partout » mais « la référence sur
   * tout ce qui passe par HTTP » — cf. getWatchingUrlHls.
   */
  export const getWatchingUrlRtsp = (broadcastingChannel : EnrichedBroadcastingChannel): string => {
    
    if ( broadcastingChannel.uuid && broadcastingChannel.uuid !== '' ) 
       {
            return `rtsp://${WWW_DOMAIN}/${broadcastingChannel.uuid}`
       }
    
      return''
  }

  export const getWatchingUrlIpTv = (broadcastingChannel : EnrichedBroadcastingChannel): string => {
    
    if ( broadcastingChannel.uuid && broadcastingChannel.uuid !== '' ) 
       {
            return `https://${WWW_DOMAIN}`
       }
    
      return''
  }

  /**
   * L'adresse HLS de la chaîne — celle du RETOUR de la fiche comme celle d'un
   * spectateur. Elle passe par HTTP, donc elle porte la RÉFÉRENCE PUBLIQUE :
   * l'uuid ne route plus, il rend 410.
   *
   * C'est ce qui a laissé le retour de la fiche noir après la fermeture de la
   * voie live, alors que la régie, elle, était déjà passée à la référence.
   */
  export const getWatchingUrlHls = (broadcastingChannel : EnrichedBroadcastingChannel): string => {
    
    if ( broadcastingChannel.publicRef && broadcastingChannel.publicRef !== '' ) 
       {
            return `https://${WWW_DOMAIN}/${broadcastingChannel.publicRef}/index.m3u8`
       }
    
      return''
  }

  /**
   * L'adresse du portail public (kleon.tv/<slug>) — le vrai slug de la
   * chaîne, celui que get_live_streams expose et que le portail résout,
   * jamais un slug redérivé du nom ici : les deux pourraient diverger
   * (nom modifié après coup, slug édité à la main) et pointer une adresse
   * que le portail ne reconnaît pas.
   */
  export const getPublicWatchingUrl = (broadcastingChannel : EnrichedBroadcastingChannel): string => {

    if ( broadcastingChannel.slug && broadcastingChannel.slug !== '' )
       {
            return `${WWW_URLS.portal_front}/${broadcastingChannel.slug}`
       }

      return''
  }

  // RTMP clair (:1935) gardé en repli ; RTMPS (:1936, TLS terminé sur HAProxy) à privilégier.
  // Le port est explicite dans les deux cas : sans lui, OBS part sur 443 en rtmps.
  export const getIngressUrlRtmp = (): string => {
    
            return `rtmp://${WWW_DOMAIN}:1935`
  }

  export const getIngressUrlRtmps = (): string => {
    
            return `rtmps://${WWW_DOMAIN}:1936`
  }

  export const getIngressUrlKey = (broadcastingChannel : EnrichedBroadcastingChannel): string => {
    
    if ( broadcastingChannel.uuid && broadcastingChannel.uuid !== '' ) 
       {
            // Les identifiants de publication RTMP voyagent DANS la clé : OBS n'a que deux
            // champs (serveur, clé), et MediaMTX lit ?user=&pass= dans le nom du flux.
            const { rtmpLogin, rtmpPassword } = broadcastingChannel
            const credentials = rtmpLogin && rtmpPassword
              ? `?user=${encodeURIComponent(rtmpLogin)}&pass=${encodeURIComponent(rtmpPassword)}`
              : ''
            return `live_${broadcastingChannel.uuid}${credentials}`
       }
    
      return''
  }



/**
 * Récupère le programme de la chaîne
 */
export const getProgramMetadata = async (
  channelPublicRef: string,
  options?: { todayOnly?: boolean }
): Promise<ProgramMetadata | null> => {

    // todayOnly borne la réponse à la journée en cours, dans le fuseau de la chaîne
    // (CHANNEL_TIMEZONE côté microservice) — la vidéo à l'antenne étant toujours
    // conservée, même si son créneau a commencé la veille.
    const query = options?.todayOnly ? '?today_only=true' : '';
    const url = `https://${WWW_DOMAIN}/${channelPublicRef}/metadata/schedule/program${query}`;

	console.log ('getProgramMetadata', url)

  try {
    const response = await axios.get<ProgramMetadata>(url);
    
		console.log ('getProgramMetadata', response)

    if (response.status === 200) {
      return response.data;
    }
    
    return null;
  } catch (error) {
	  
	  		console.log ('getProgramMetadata', error)

    console.error('Erreur lors de la récupération du programme:', error);
    return null;
  }
};


/**
 * Construit l'URL de la vignette d'une vidéo.
 *
 * ⚠️ Le paramètre s'appelait `mediaUuid`, et c'était un piège : l'uuid ne compose
 * plus aucune adresse servable depuis que les ressources sont rangées par
 * créateur. Les appelants passent bien un publicRef ; le nom, lui, invitait à
 * l'erreur suivante.
 */
export const getThumbnailUrl = (publicRef: string): string => {
  return `${WWW_URLS.MediaServer}${publicRef}/images/thumbnail.webp`;
};

/**
 * Récupère les métadonnées de la vidéo en cours de diffusion
 */
export const getCurrentStreamMetadata = async (
  channelPublicRef: string
): Promise<CurrentStreamMetadata | null> => {

    const url = `https://${WWW_DOMAIN}/${channelPublicRef}/metadata/schedule/current`;

	console.log ('getCurrentStreamMetadata', url)

  try {

    const response = await axios.get<CurrentStreamMetadata>(url);
    
	console.log ('getCurrentStreamMetadata', response)
	
    if (response.status === 200) {
      return response.data;
    }
    
    return null;
  } catch (error) {

	console.log ('getCurrentStreamMetadata', error)

    console.error('Erreur lors de la récupération des métadonnées courantes:', error);
    return null;
  }
};